/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Relaxed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Relaxed"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#FFC220"
        d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
        className="Fill-Main"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M14.744 14.744a.834.834 0 0 1 1.178 1.178 5.547 5.547 0 0 1-7.844 0 .834.834 0 0 1 1.178-1.178 3.88 3.88 0 0 0 5.488 0m-5-5.833a.834.834 0 0 1 1.178 1.178 3.19 3.19 0 0 1-4.511 0A.834.834 0 0 1 7.59 8.912a1.523 1.523 0 0 0 2.154 0m6.667 0a.834.834 0 0 1 1.178 1.178 3.19 3.19 0 0 1-4.511 0 .834.834 0 0 1 1.178-1.178c.595.595 1.56.595 2.155 0"
        className="Fill-Secondary"
      />
    </g>
  </svg>
);

export const RelaxedIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'relaxed-icon'}
      icon={Relaxed}
      {...props}
      size={size}
    />
  );
};
